
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutlv6i1FL0CfMeta } from "/opt/build/repo/pages/about.vue?macro=true";
import { default as cartl5ckCViQWgMeta } from "/opt/build/repo/pages/cart.vue?macro=true";
import { default as contactNfojXvLlAkMeta } from "/opt/build/repo/pages/contact.vue?macro=true";
import { default as _91handle_93ajDaAQ6BHqMeta } from "/opt/build/repo/pages/events/[handle].vue?macro=true";
import { default as _91token_93XsF9xWuQBmMeta } from "/opt/build/repo/pages/events/discounts/[token].vue?macro=true";
import { default as indexHR5Bie6djpMeta } from "/opt/build/repo/pages/events/index.vue?macro=true";
import { default as _91slug_93eIlpbSsqvaMeta } from "/opt/build/repo/pages/help/faqs/[slug].vue?macro=true";
import { default as indexRXSbZUpVliMeta } from "/opt/build/repo/pages/help/faqs/index.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as _91id_93idQeJy1JFhMeta } from "/opt/build/repo/pages/itm/[id].vue?macro=true";
import { default as _91handle_93GvZrYbdWNqMeta } from "/opt/build/repo/pages/legal/[handle].vue?macro=true";
import { default as indexlWyU3b38IQMeta } from "/opt/build/repo/pages/legal/index.vue?macro=true";
import { default as previewAhKeF96wPcMeta } from "/opt/build/repo/pages/preview.vue?macro=true";
import { default as _91handle_93Jhfzip6ZHSMeta } from "/opt/build/repo/pages/products/[handle].vue?macro=true";
import { default as indextMtonKiU6yMeta } from "/opt/build/repo/pages/products/index.vue?macro=true";
import { default as indexdeTKHVjnKUMeta } from "/opt/build/repo/pages/recipes/index.vue?macro=true";
import { default as registeryZbpxRGV6SMeta } from "/opt/build/repo/pages/register.vue?macro=true";
import { default as _91handle_93OWPyOTSLTDMeta } from "/opt/build/repo/pages/s/[handle].vue?macro=true";
import { default as _91payload_935xBJAcH8IUMeta } from "/opt/build/repo/pages/s/profile/[payload].vue?macro=true";
import { default as appointmentsfOe8J2kChGMeta } from "/opt/build/repo/pages/sell/appointments.vue?macro=true";
import { default as commerceJQjreBL5RoMeta } from "/opt/build/repo/pages/sell/commerce.vue?macro=true";
import { default as contactWH6YqTJ5DJMeta } from "/opt/build/repo/pages/sell/contact.vue?macro=true";
import { default as eventsdPzq3yMqbiMeta } from "/opt/build/repo/pages/sell/events.vue?macro=true";
import { default as indexvQD3vJF7tSMeta } from "/opt/build/repo/pages/sell/index.vue?macro=true";
import { default as pricingPw3hWJtJ5ZMeta } from "/opt/build/repo/pages/sell/pricing.vue?macro=true";
import { default as _91service_939pesku2B3bMeta } from "/opt/build/repo/pages/services/[provider]/[service].vue?macro=true";
import { default as indexMZD99YG3wjMeta } from "/opt/build/repo/pages/services/[provider]/index.vue?macro=true";
import { default as bookingedIeQEV2wSMeta } from "/opt/build/repo/pages/services/booking.vue?macro=true";
import { default as indexi5MzpDfjPNMeta } from "/opt/build/repo/pages/services/index.vue?macro=true";
import { default as rescheduleZy31w6iQGdMeta } from "/opt/build/repo/pages/services/reschedule.vue?macro=true";
import { default as thank_45youLjYQltUuVZMeta } from "/opt/build/repo/pages/thank-you.vue?macro=true";
import { default as component_45stubRU5sOBTecHMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubRU5sOBTecH } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutlv6i1FL0CfMeta || {},
    component: () => import("/opt/build/repo/pages/about.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: cartl5ckCViQWgMeta || {},
    component: () => import("/opt/build/repo/pages/cart.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactNfojXvLlAkMeta || {},
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "events-handle",
    path: "/events/:handle()",
    meta: _91handle_93ajDaAQ6BHqMeta || {},
    component: () => import("/opt/build/repo/pages/events/[handle].vue")
  },
  {
    name: "events-discounts-token",
    path: "/events/discounts/:token()",
    meta: _91token_93XsF9xWuQBmMeta || {},
    component: () => import("/opt/build/repo/pages/events/discounts/[token].vue")
  },
  {
    name: "events",
    path: "/events",
    meta: indexHR5Bie6djpMeta || {},
    component: () => import("/opt/build/repo/pages/events/index.vue")
  },
  {
    name: "help-faqs-slug",
    path: "/help/faqs/:slug()",
    meta: _91slug_93eIlpbSsqvaMeta || {},
    component: () => import("/opt/build/repo/pages/help/faqs/[slug].vue")
  },
  {
    name: "help-faqs",
    path: "/help/faqs",
    meta: indexRXSbZUpVliMeta || {},
    component: () => import("/opt/build/repo/pages/help/faqs/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "itm-id",
    path: "/itm/:id()",
    meta: _91id_93idQeJy1JFhMeta || {},
    component: () => import("/opt/build/repo/pages/itm/[id].vue")
  },
  {
    name: "legal-handle",
    path: "/legal/:handle()",
    meta: _91handle_93GvZrYbdWNqMeta || {},
    component: () => import("/opt/build/repo/pages/legal/[handle].vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: indexlWyU3b38IQMeta || {},
    component: () => import("/opt/build/repo/pages/legal/index.vue")
  },
  {
    name: "preview",
    path: "/preview",
    meta: previewAhKeF96wPcMeta || {},
    component: () => import("/opt/build/repo/pages/preview.vue")
  },
  {
    name: "products-handle",
    path: "/products/:handle()",
    meta: _91handle_93Jhfzip6ZHSMeta || {},
    component: () => import("/opt/build/repo/pages/products/[handle].vue")
  },
  {
    name: "products",
    path: "/products",
    meta: indextMtonKiU6yMeta || {},
    component: () => import("/opt/build/repo/pages/products/index.vue")
  },
  {
    name: "recipes",
    path: "/recipes",
    component: () => import("/opt/build/repo/pages/recipes/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registeryZbpxRGV6SMeta || {},
    component: () => import("/opt/build/repo/pages/register.vue")
  },
  {
    name: "s-handle",
    path: "/s/:handle()",
    meta: _91handle_93OWPyOTSLTDMeta || {},
    component: () => import("/opt/build/repo/pages/s/[handle].vue")
  },
  {
    name: "s-profile-payload",
    path: "/s/profile/:payload()",
    meta: _91payload_935xBJAcH8IUMeta || {},
    component: () => import("/opt/build/repo/pages/s/profile/[payload].vue")
  },
  {
    name: "sell-appointments",
    path: "/sell/appointments",
    meta: appointmentsfOe8J2kChGMeta || {},
    component: () => import("/opt/build/repo/pages/sell/appointments.vue")
  },
  {
    name: "sell-commerce",
    path: "/sell/commerce",
    meta: commerceJQjreBL5RoMeta || {},
    component: () => import("/opt/build/repo/pages/sell/commerce.vue")
  },
  {
    name: "sell-contact",
    path: "/sell/contact",
    meta: contactWH6YqTJ5DJMeta || {},
    component: () => import("/opt/build/repo/pages/sell/contact.vue")
  },
  {
    name: "sell-events",
    path: "/sell/events",
    meta: eventsdPzq3yMqbiMeta || {},
    component: () => import("/opt/build/repo/pages/sell/events.vue")
  },
  {
    name: "sell",
    path: "/sell",
    meta: indexvQD3vJF7tSMeta || {},
    component: () => import("/opt/build/repo/pages/sell/index.vue")
  },
  {
    name: "sell-pricing",
    path: "/sell/pricing",
    meta: pricingPw3hWJtJ5ZMeta || {},
    component: () => import("/opt/build/repo/pages/sell/pricing.vue")
  },
  {
    name: "services-provider-service",
    path: "/services/:provider()/:service()",
    meta: _91service_939pesku2B3bMeta || {},
    component: () => import("/opt/build/repo/pages/services/[provider]/[service].vue")
  },
  {
    name: "services-provider",
    path: "/services/:provider()",
    meta: indexMZD99YG3wjMeta || {},
    component: () => import("/opt/build/repo/pages/services/[provider]/index.vue")
  },
  {
    name: "services-booking",
    path: "/services/booking",
    meta: bookingedIeQEV2wSMeta || {},
    component: () => import("/opt/build/repo/pages/services/booking.vue")
  },
  {
    name: "services",
    path: "/services",
    meta: indexi5MzpDfjPNMeta || {},
    component: () => import("/opt/build/repo/pages/services/index.vue")
  },
  {
    name: "services-reschedule",
    path: "/services/reschedule",
    component: () => import("/opt/build/repo/pages/services/reschedule.vue")
  },
  {
    name: "thank-you",
    path: "/thank-you",
    meta: thank_45youLjYQltUuVZMeta || {},
    component: () => import("/opt/build/repo/pages/thank-you.vue")
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/ecommerce",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/faq",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/faqs",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/contact-us",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/pricing",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/plans",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/signup",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/gamesnight",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sipngraze",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/lnk/icsa",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/iriji",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/nigeria2025",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "tg",
    component: component_45stubRU5sOBTecH
  }
]